import { actions } from './Reducer';

export const getArtisanPrivateInquiryAction = payload => ({
  type: actions.GET_ARTISAN_PRIVATE_INQUIREY,
  payload
});

export const getArtisanPrivateInquiriesAction = payload => ({
  type: actions.GET_ARTISAN_PRIVATE_INQUIRIES,
  payload
});

export const getArtisanPrivateInquirySuccessAction = privateInquiry => ({
  type: actions.GET_ARTISAN_PRIVATE_INQUIREY_SUCCESS,
  payload: privateInquiry
});

export const getArtisanPrivateInquiriesSuccessAction = privateInquiries => ({
  type: actions.GET_ARTISAN_PRIVATE_INQUIRIES_SUCCESS,
  payload: privateInquiries
});

export const getArtisanPrivateStagingInquiriesAction = staging => ({
  type: actions.GET_ARTISAN_PRIVATE_STAGING_INQUIRIES,
  payload: staging
});
export const getArtisanPrivateStagingInquiriesSuccessAction = staging => ({
  type: actions.GET_ARTISAN_PRIVATE_STAGING_INQUIRIES_SUCCESS,
  payload: staging
});

export const setArtisanPrivateInquiryIsLoading = isLoading => ({
  type: actions.ARTISAN_PRIVATE_INQUIREY_IS_LOADING,
  payload: isLoading
});

export const deleteArtisanPrivateInquiryAction = (id, url) => {
  console.log(id,url, 'deletee');
  return {
    type: actions.DELETE_PRIVATE_ARTISAN_INQUIRY,
    payload: {id,url}
  };
};

export const deleteArtisanPrivateInquirySuccessAction = id => ({
  type: actions.DELETE_PRIVATE_ARTISAN_INQUIRY_SUCCESS,
  payload: id
});

export const editArtisanPrivateInquiryAction = (id, body) => {
  console.log(id, body);
  return {
    type: actions.EDIT_PRIVATE_ARTISAN_INQUIRY,
    payload: {
      id,
      body
    }
  };
};

export const editArtisanPrivateInquirySuccessAction = inquiry => ({
  type: actions.EDIT_PRIVATE_ARTISAN_INQUIRY_SUCCESS,
  payload: inquiry
});

export const addArtisanPrivateInquiryAction = body => ({
  type: actions.ADD_PRIVATE_ARTISAN_INQUIRY,
  payload: body
});

export const addArtisanPrivateInquirySuccessAction = inquiry => ({
  type: actions.ADD_PRIVATE_ARTISAN_INQUIRY_SUCCESS,
  payload: inquiry
});

export const setPrivateArtisanInquiryAction = count => ({
  type: actions.SET_PRIVATE_ARTISAN_INQUIRY_COUNT,
  payload: count
});
